const sizes = {
  xs: 600,
  sm: 960,
  md: 1280,
  lg: 1920,
  xl: Infinity,
};
export const getScreenSize = () => Object.keys(sizes).find(key => sizes[key] > window.innerWidth);
